@if (clientsCount > 0) {
  <ion-list>
    @for (client of (clients$ | async); track client) {
      <app-item
        [icon]="client.temporal ? 'phone-portrait-outline' : 'person-outline'"
        (click)="handleClick(client)">
        <ion-label>
          <h2>{{ client.name }} ({{ client.completeNumber }})</h2>
          <p>{{ client.phone }}</p>
        </ion-label>
      </app-item>
    }
  </ion-list>
  <ion-infinite-scroll [disabled]="infiniteScrollDisabled" threshold="50px" (ionInfinite)="loadMoreClients($event)">
    <ion-infinite-scroll-content loadingSpinner="circular" [loadingText]="'lbl_processing' | translate">
    </ion-infinite-scroll-content>
  </ion-infinite-scroll>
}

@if (clientsCount === 0 && !(loading$ | async)) {
  <app-item class="no-clients-item" [detailIcon]="false" lines="none">
    <h4>{{ 'val_client_search' | translate }}</h4>
  </app-item>
}
